import React, { Component } from "react";
import lang from '../../lang';
import ListPannel from './list-pannel';
import Tooltip from 'rc-tooltip';

class SearchUser extends Component {

	constructor(props) {
		super(props);
		this.state = {
			keyword: '',
			showSearchResult: false
		};
	}

	keyupHanlder(e) {
		let el = $(e.currentTarget);
		
		this.timer && clearTimeout(this.timer);
		
		this.timer = setTimeout(()=>{
			this.setState({
				keyword: el.val()
			});
		}, 400);
	}

	onKeyDown=(e)=>{
        if (e.keyCode ==  13) { // 按Enter
            this.handleSearch();
        }
    }

	componentDidMount() {
		$(document.body).on('click', (e)=>{
			let el = $(e.target);
			let showSearchResult = false;
			if ($('.s-result').find(el).length > 0 || $('.search').find(el).length > 0) {
				showSearchResult = true;
			}
			this.setState({
				showSearchResult
			});
		});

		$.channel.on('hideSearchResult', ()=>{
			this.setState({
				showSearchResult: false
			});
			this.refs.search.value = '';
		})
	}

	componentWillUnmount(){
		$(document.body).off('click');
		$.channel.off('hideSearchResult');
	}

	onScroll=(e) =>{
		this.refs.list && this.refs.list.scroll(e);
	}

	handleSearch=()=>{
		let val = this.refs.search.value.trim();

		if (val == '') {
			return;
		}

		this.setState({
			keyword: val
		});
	}

	render() {

		let keyword = this.state.keyword;

		$pop = (

			<div className={`s-result s-result-pop ${keyword ? "" :"hidden" }`}>

				<div className="s-result-scroller hostlist-lite" onScroll={this.onScroll}>
					{ keyword ? <ListPannel keyword={keyword} showFollowInfo="true" ref="list"/> : null }
				</div>
			</div>
		)
		
		return (
			<div className="search" ref="search">
				<Tooltip getTooltipContainer={()=>this.refs.search} overlay={$pop} placement="bottom" trigger={['click']} overlayClassName="header-popover header-search-popover">
                    
                    <div className="result-pop-hd">
						<div className="input-wrap">
							<input 
								type="text"
								autoComplete="off"
								className="search-user-input" 
								ref="search" 
								placeholder={lang.template('请输入用户昵称或Up号')}
								onChange={this.keyupHanlder.bind(this)}
								onKeyDown={this.onKeyDown}
								maxLength="15"
							/>
							<span className="search-icon">{lang.template('搜索')}</span>
						</div>
					</div>
                    

				</Tooltip>

			</div>
		);
	}
}

export default SearchUser;



// WEBPACK FOOTER //
// ./js/header/searchuser/index.js